import { Item } from '../../../types/interfaces';
import { useCartItemQuantity } from '../hooks/useCartItemQuantity';

interface CartItemLogicProps {
  item: Item;
  CartItemUI: (props: {
    item: Item;
    quantity: number;
    verificationQuantity: number;
    onQuantityChange: (value: number) => void;
    onVerificationQuantityChange: (value: number) => void;
    removeFromCart: () => void;
    removeVerifyHandler: (id: number) => void;
    addingItemToCart: (params: { quantity: number; verificationQuantity: number }) => void;
    isSelected?: boolean;
    onSelectChange?: (checked: boolean) => void;
  }) => JSX.Element;
  isSelected?: boolean;
  onSelectChange?: (checked: boolean) => void;
}

export const CartItemLogic = ({
  item,
  CartItemUI,
  isSelected = false,
  onSelectChange,
}: CartItemLogicProps): JSX.Element => {
  const {
    quantity,
    verificationQuantity,
    handleQuantityChange,
    handleVerificationChange,
    removeFromCart,
    removeVerification,
    dispatchUpdate,
  } = useCartItemQuantity(item);

  const addingItemToCart = ({
    quantity,
    verificationQuantity,
  }: {
    quantity: number;
    verificationQuantity: number;
  }) => {
    dispatchUpdate(quantity, verificationQuantity);
  };

  return (
    <CartItemUI
      item={item}
      quantity={quantity}
      verificationQuantity={verificationQuantity}
      onQuantityChange={handleQuantityChange}
      onVerificationQuantityChange={handleVerificationChange}
      removeFromCart={removeFromCart}
      removeVerifyHandler={removeVerification}
      addingItemToCart={addingItemToCart}
      isSelected={isSelected}
      onSelectChange={onSelectChange}
    />
  );
};
